import * as req from 'api/actions';
import * as c from './constant';

export const dummy = () => {};

export const getList = (payload = {}, callback) =>
  req.list(
    c.LIST,
    'api/v1/administrators/ordinance_violation_receipts/csv_imports',
    payload,
    callback
  );

